// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginForm_wrapper__pKUlg","content":"LoginForm_content__uVYl2","contWrapper":"LoginForm_contWrapper__kSWhH","h1":"LoginForm_h1__xnwjk","item":"LoginForm_item__jswy1"};